export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_18.9d5317e4.jpg";